import '../tables/Table.module.css'
import '../css_styles/button_styles.css'
import classes from '../tables/Table.module.css'

function ObjectiveTableViewer(props) {

    let colGroup = (<>
            <colgroup>
                    <col style={{minWidth:'150px'}} />
                    <col style={{minWidth:'90px'}} />
                    <col style={{minWidth:'60px'}} />
                    <col style={{minWidth:'90px'}} />
                    <col style={{minWidth:'140px'}} />
                    <col style={{minWidth:'140px'}} />
                    <col style={{minWidth:'140px'}} />
                    <col style={{minWidth:'140px'}} />
                    <col style={{minWidth:'140px'}} />
                    <col style={{minWidth:'250px'}} />
            </colgroup> 
        </>);

    let tableHead = (
        <>
            <tr style={{fontSize: '14px'}}>
                <th>Response Name</th>
                <th>Type</th>
                <th>Unit</th>
                <th>Sub-Score</th>
                <th>Typical Range</th>
                <th>Go-Criteria</th>
                <th>Target <br/>({'\u25CB'}{'\u25CB'}/{'\u25CB'})</th>
                <th>Okay<br/>({'\u25B3'})</th>
                <th>No-Good<br/><span style={{fontWeight:'300'}}>(x/xx)</span></th>
                <th>Remarks</th>
            </tr>
        </>);


    function input_interval(range_min, range_max){
        const interval = (<>
            <div style={{ display:'flex', fontSize: '14px' }}>
                <div style={{fontSize: '14px'}}>
                    [{range_min}, {range_max}]
                </div> 
            </div>
        </>);
        return interval;
    }


    function input_value(val){
        const input_field = (<>
            <div style={{ display:'flex', fontSize: '14px' }}>
                <div style={{fontSize: '14px'}}>
                    {val}
                </div>
            </div>
        </>);
    return input_field;
    }


    function input_csv_list(list_vals){
        let csv_list = '';
        let csv_input = (<></>);
        if (list_vals.length > 0) { 
            csv_list = list_vals.join(', ');
            csv_input = (<>
                <div style={{fontSize: '14px'}}> 
                [{csv_list}]
                </div>
            </>);
        }
    return csv_input;
    }


    function ranking_tier_segment(key_name, key_id, id_segment, segment_data){
        // if all_segments.length > 0
        function selector(type) {
            let select = (<></>);
            if (type === 'Interval'){ select = (<></>); }
            if (type === 'LE'){ select = (<><div style={{fontSize: '14px'}}>&le;</div></>); }
            if (type === 'L'){ select = (<><div style={{fontSize: '14px'}}>&lt;</div></>); }
            if (type === 'GE'){ select = (<><div style={{fontSize: '14px'}}>&ge;</div></>); }
            if (type === 'G'){ select = (<><div style={{fontSize: '14px'}}>&gt;</div></>); }
            return select;
        }
        
        let input_mask = (<></>);
        if(segment_data.type === 'Interval'){
            let range_min = segment_data.min;
            let range_max = segment_data.max;
            input_mask = input_interval(range_min, range_max);
        }
        else{
            let val = segment_data.val
            input_mask = input_value(val);
        }
        const segment = (<>
                    <div key={`${key_name}_${key_id}_${id_segment}`} style={{display:'flex', justifyContent: 'center', alignItems:'center'}}>
                        {selector(segment_data.type)}
                        {input_mask}
                    </div>
                </>);
        return segment
    }


    let tableRows =props.objectives.map((objective, id) => {

        // define input for relevant range
        let relevant_range = (<span style={{fontSize: '14px', color:'var(--aixelo-gray'}}>N/A</span>);
        if(objective.type === 'Continuous' && (objective.is_score === true || objective.go_nogo === true)){
            relevant_range =  input_interval(objective.range_continuous.min, objective.range_continuous.max)
        }
        if(objective.type === 'Discrete' && (objective.is_score === true || objective.go_nogo === true)){
            relevant_range =  input_csv_list(objective.range_discrete.list_vals)
        }

        // define input for target/okay/no_good/go_nogo
        let target = (<span style={{fontSize: '14px', color:'var(--aixelo-gray'}}>N/A</span>);
        let okay = (<span style={{fontSize: '14px', color:'var(--aixelo-gray'}}>N/A</span>);
        let no_good = (<span style={{fontSize: '14px', color:'var(--aixelo-gray'}}>N/A</span>);
        let go_criteria = (<span style={{fontSize: '14px', color:'var(--aixelo-gray'}}>N/A</span>);
 
        if (objective.type === 'Continuous' && objective.is_score === true) {

                target = []
                for(let i=0; i< objective.target.length; i++)
                {
                    let id_segment = i
                    let segment_data = objective.target[i];
                    let ranking_tier = ranking_tier_segment('target', id, id_segment, segment_data);
                    if (i < objective.target.length-1) {
                        target.push((<div style={{display:'flex', marginBottom:'3px'}}>{ranking_tier}<div style={{ fontSize: '14px' }}> &nbsp; or</div></div>));
                    }
                    else {
                        target.push((<div style={{display:'flex', marginBottom:'3px'}}>{ranking_tier}</div>));
                    }
                }

                okay = []
                for(let i=0; i< objective.okay.length; i++)
                {
                    let id_segment = i
                    let segment_data = objective.okay[i];
                    let ranking_tier = ranking_tier_segment('okay', id, id_segment, segment_data);
                    if (i < objective.okay.length-1) {
                        okay.push((<div style={{display:'flex', marginBottom:'3px'}}>{ranking_tier}<div style={{ fontSize: '14px' }}> &nbsp; or</div></div>));
                    }
                    else {
                        okay.push((<div style={{display:'flex', marginBottom:'3px'}}>{ranking_tier}</div>));
                    }
                }

                no_good = []
                for(let i=0; i< objective.no_good.length; i++)
                {
                    let id_segment = i
                    let segment_data = objective.no_good[i];
                    let ranking_tier = ranking_tier_segment('nogood', id, id_segment, segment_data);
                    if (i < objective.no_good.length-1) {
                        no_good.push((<div style={{display:'flex', marginBottom:'3px'}}>{ranking_tier}<div style={{ fontSize: '14px' }}> &nbsp; or</div></div>));
                    }
                    else {
                        no_good.push((<div style={{display:'flex', marginBottom:'3px'}}>{ranking_tier}</div>));
                    }
                }
        }

        if (objective.type === 'Discrete' && objective.is_score === true) {
            let target_list_vals = []
            if (objective.target.length >0 ){
                target_list_vals = objective.target[0].list_vals;
            }
            let okay_list_vals = []
            if (objective.okay.length >0 ){
                okay_list_vals = objective.okay[0].list_vals;
            }
            let no_good_list_vals = []
            if (objective.no_good.length >0 ){
                no_good_list_vals = objective.no_good[0].list_vals;
            }
            target = input_csv_list(target_list_vals)
            okay = input_csv_list(okay_list_vals)
            no_good = input_csv_list(no_good_list_vals)
        }

        if (objective.type === 'Continuous' && objective.go_nogo === true) {

                go_criteria = []
                for(let i=0; i< objective.go_criteria.length; i++)
                {
                    let id_segment = i
                    let segment_data = objective.go_criteria[i];
                    let ranking_tier = ranking_tier_segment('gocriteria', id, id_segment, segment_data);
                    if (i < objective.target.length-1) {
                        go_criteria.push((<div style={{display:'flex', marginBottom:'3px'}}>{ranking_tier}<div style={{ fontSize: '14px' }}> &nbsp; or</div></div>));
                    }
                    else {
                        go_criteria.push((<div style={{display:'flex', marginBottom:'3px'}}>{ranking_tier}</div>));
                    }
                }
        }

        if (objective.type === 'Discrete' && objective.go_nogo === true) {
            let go_criteria_list_vals = []
            if (objective.go_criteria.length >0 ){
                go_criteria_list_vals = objective.go_criteria[0].list_vals;
            }
            go_criteria = input_csv_list(go_criteria_list_vals)
        }

        function subscore(is_score){
            if (is_score){ return 'yes';}
            else {return 'no'}
        }

        return (
            <tr key={`row_${id}`} >
                <td key={`name_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px' }}>
                        {objective.name}
                    </div>
                </td>
                <td key={`type_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px' }}> 
                       {objective.type} 
                    </div>
                </td>
                <td key={`units_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px' }}> 
                       {objective.units} 
                    </div>
                </td>
                <td key={`is_score_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px' }}>
                        {subscore(objective.is_score)}
                    </div>
                </td>
                <td key={`range_${id}`} style={{verticalAlign: 'top'}}>
                    {relevant_range}
                </td>
                <td key={`go_criteria_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{display:'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                        {go_criteria}
                    </div>
                </td>
                <td key={`target_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{display:'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                        {target}
                    </div>
                </td>
                <td key={`okay_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{display:'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                        {okay}
                    </div>
                </td>
                <td key={`no_good_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{display:'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}}>
                        {no_good}
                    </div>
                </td>
                <td key={`remarks_${id}`} style={{verticalAlign: 'top'}}>
                    <div style={{ fontSize: '14px' }}> 
                        {objective.remarks} 
                    </div>
                </td>
            </tr>
        );
    });

    let showMin = 1;
    let showMax = props.objectives.length;
    let numRows = props.objectives.length;
    let show_min_max=(<>{showMin}-{showMax} of {numRows}</>);

    let pageNav = (<></>);
            pageNav = (<>
            <div className={classes.page_nav} style={{position:'relative', height:'20px', width: '100%'}}>
                <div style={{paddingRight:'20px', paddingBottom:'4px', }}>{show_min_max} </div>
            </div>
        </>);
    


    return(<>
        {pageNav}
        <table style={{marginBottom:'5px'}}> 
        {colGroup}
            <thead >
                {tableHead}
            </thead>
            <tr><div style={{height: '4px'}} colSpan={10}></div></tr>
            <tbody style={{border: '0.5px solid var(--aixelo-gray-light)'}}>
                {tableRows}
            </tbody>
        </table>
    </>
    );

}


export default ObjectiveTableViewer;
